import { render } from "./slide7.vue?vue&type=template&id=0dfa40cf"
import script from "./slide7.vue?vue&type=script&lang=js"
export * from "./slide7.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__